/* eslint-disable no-param-reassign */
const ViewToggle = {
	init({ element }) {
		this.viewSelector = element;
		this.targetElements = document.querySelectorAll('.view-toggle-target');
		this.viewTypeText = document.querySelector('.view-type');
		this.viewLayout = document.querySelector('.view-layout');

		this.viewSelector.addEventListener('click', () => {
			this.targetElements.forEach((el) => {
				this.toggleView(el);
			});
		});
	},

	toggleView(element) {
		if (element.classList.contains('cards-grid')) {
			element.classList.replace('cards-grid', 'cards-list');
			this.viewTypeText.innerHTML = 'Bekijk in blokken';
			this.viewLayout.src = '/images/layout-grid.svg';
		} else if (element.classList.contains('cards-list')) {
			element.classList.replace('cards-list', 'cards-grid');
			this.viewTypeText.innerHTML = 'Bekijk als lijst';
			this.viewLayout.src = '/images/layout-list.svg';
		}
	},
};

export { ViewToggle as default };
